"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubtaskForRetryEvent = exports.isDropTempTableEvent = exports.isTaskFinishedEvent = exports.isSubtaskDoneEvent = exports.isJobStartEvent = exports.TaskEventType = exports.SubtaskStatus = exports.TaskStatus = exports.WorkerEventType = void 0;
var WorkerEventType;
(function (WorkerEventType) {
    WorkerEventType["SUBTASK_START"] = "subtask_start";
})(WorkerEventType = exports.WorkerEventType || (exports.WorkerEventType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["WAITING"] = "waiting";
    TaskStatus["PROCESSING"] = "processing";
    TaskStatus["FINISHED"] = "finished";
    TaskStatus["ERROR_CLEANUP_PENDING"] = "error_cleanup_pending";
    TaskStatus["ERROR_CLEANUP_DONE"] = "error_cleanup_done";
    TaskStatus["CANCELED"] = "canceled";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var SubtaskStatus;
(function (SubtaskStatus) {
    SubtaskStatus["WAITING"] = "waiting";
    SubtaskStatus["PROCESSING"] = "processing";
    SubtaskStatus["FINISHED"] = "finished";
    SubtaskStatus["ERROR"] = "error";
    SubtaskStatus["CANCELED"] = "canceled";
})(SubtaskStatus = exports.SubtaskStatus || (exports.SubtaskStatus = {}));
var TaskEventType;
(function (TaskEventType) {
    TaskEventType["JOB_FINISHED"] = "job_finished";
    TaskEventType["JOB_START"] = "job_start";
    TaskEventType["SUBTASK_FINISHED"] = "subtask_finished";
    TaskEventType["TASK_FINISHED"] = "task_finished";
    TaskEventType["DROP_TEMP_TABLE"] = "drop_temp_table";
    TaskEventType["SUBTASK_FOR_RETRY"] = "subtask_for_retry";
})(TaskEventType = exports.TaskEventType || (exports.TaskEventType = {}));
const isJobStartEvent = (event) => {
    return event.type === TaskEventType.JOB_START;
};
exports.isJobStartEvent = isJobStartEvent;
const isSubtaskDoneEvent = (event) => {
    return event.type === TaskEventType.SUBTASK_FINISHED;
};
exports.isSubtaskDoneEvent = isSubtaskDoneEvent;
const isTaskFinishedEvent = (event) => {
    return event.type === TaskEventType.TASK_FINISHED;
};
exports.isTaskFinishedEvent = isTaskFinishedEvent;
const isDropTempTableEvent = (event) => {
    return event.type === TaskEventType.DROP_TEMP_TABLE;
};
exports.isDropTempTableEvent = isDropTempTableEvent;
const isSubtaskForRetryEvent = (event) => {
    return event.type === TaskEventType.SUBTASK_FOR_RETRY;
};
exports.isSubtaskForRetryEvent = isSubtaskForRetryEvent;
